import { autorun, intercept, observe, reaction } from "mobx";
import { initExtends } from "./initExtends";
export { transaction, runInAction, flow, autorun, reaction, observe, action } from "mobx";
export { observer, useLocalObservable } from "mobx-react";
export function $observe(vm, key, listener, invokeImmediately) {
    return observe(vm, key, listener, invokeImmediately);
}
export function $intercept(vm, key, handler) {
    return intercept(vm, key, handler);
}
export function $reaction(expression, effect) {
    return !effect ? autorun(expression) : reaction(expression, function() {
        return effect();
    });
}
export function $register(vm, properties) {
    return initExtends(vm, properties);
}
